module.exports = __webpack_public_path__ + "img/ic-canvas-comment-hover.6d18374b.svg";